import DOMPurify from "dompurify";
import MegaBall from "./MegaBall";
import TicketDigits from "./TicketDigits";

class Card extends React.Component {
  constructor(props) {
    super(props);
    this.getDataKey = this.getDataKey.bind(this);
    this.loopDigits = this.loopDigits.bind(this);
    this.MegaBallDataKey = this.MegaBallDataKey.bind(this);
  }

  loopDigits(card) {
    let lotteryArray = [];
    for (let index = 1; index <= card; index++) {
      lotteryArray.push(index);
    }
    return lotteryArray;
  }

  getDataKey(event) {
    let UID;
    event.target
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));
    let card_id =
      event.target.parentNode.parentNode.parentNode.getAttribute("datakey") ||
      event.target.parentNode.parentNode.parentNode.parentNode.getAttribute(
        "datakey"
      );

    this.props.updateTicketDigitSelcted(UID, card_id, event.target.innerText);
  }

  MegaBallDataKey(event) {
    let UID;

    event.target
      .getAttribute("id")
      .split("-")
      .map((item) => (Number(item) !== NaN ? (UID = Number(item)) : null));
    let card_id =
      event.target.parentNode.parentNode.parentNode.parentNode.getAttribute(
        "datakey"
      ) ||
      event.target.parentNode.parentNode.parentNode.getAttribute("datakey");

    this.props.updateMegaSelected(UID, card_id, event.target.innerText);
  }

  render() {
    let lotterySelect = this.props.current_lottery,
      card = this.props.CardCount;
    const t = this.props.t;
    return (
      <>
        {this.loopDigits(card).map((display, id) => (
          <div className="card" key={id} datakey={id} id={`card-${id}`}>
            {/* main number component */}
            <div className="card__number">
              {/* selected numbers array */}
              <div className="card__info" title="pick 5 numbers">
                {" "}
                {this.props.cardData[id].selected_digits.length !== 0
                  ? this.props.cardData[id].selected_digits.map((item, index) =>
                      !Array.isArray(item) ? (
                        <div className="card__text-upper" key={index}>
                          {item}
                        </div>
                      ) : (
                        <div className="card__text-upper-Mega" key={index}>
                          {item}
                        </div>
                      )
                    )
                  : `${DOMPurify.sanitize(t("cardPickerMsg1"))} ${
                      this.props.current_lottery.maximum_digits
                    } ${DOMPurify.sanitize(t("cardPickerMsg2"))}`}{" "}
              </div>
              <div className="card__dynamic-buttons">
                <div
                  className="card__quick-pick"
                  title="quick pick lottery numbers"
                  onClick={this.props.quickPick}
                >
                  {DOMPurify.sanitize(t("cardQuickPick"))}{" "}
                </div>
                <div
                  className="card__clear"
                  title="clear selected lottery numbers"
                  onClick={this.props.clear}
                  childid={id}
                >
                  {DOMPurify.sanitize(t("cardClear"))}{" "}
                </div>
              </div>

              {/* load ticket digits component */}
              <div className="card__wrap-ticket">
                <TicketDigits
                  lottery={lotterySelect}
                  getDataKey={this.getDataKey}
                />
              </div>
            </div>

            {/* megaball components */}
            <div className="card__wrap">
              <div className={"card__number-Mega"}>
                <div className="card__heading">
                  <div className="card__info" title="choose one lucky number">
                    {DOMPurify.sanitize(t("cardPickerMsg1"))}{" "}
                    {this.props.current_lottery.max_mega_digits}{" "}
                    {DOMPurify.sanitize(t("cardPickerMsg2"))}
                  </div>
                  <div></div>
                </div>

                {/* load extra/megaball number component */}
                <MegaBall
                  lottery={lotterySelect}
                  MegaBallDataKey={this.MegaBallDataKey}
                />
              </div>
            </div>
          </div>
        ))}
      </>
    );
  }
}

export default Card;
